<ul [class.textBodyColor]="color === 'textBody'">
    <li *ngFor="let item of items" [class.textBodyColor]="color === 'textBody'">
        <a [routerLink]="item.url">{{ item.title }}</a>
    </li>
</ul>